import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { City } from '../model/property';
import { Cacheable } from '../utils/cacheable';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {
  private cityListCache: Cacheable<City[]> = new Cacheable<City[]>();

  constructor(
    private http: HttpClient
  ) {
    this.cityListCache.getHandler = () => {
      return this.http.get<City[]>(environment.api.property + '/city');
    }
  }

  getCityList(): Observable<City[]> {
    return this.cityListCache.getData();
  }
}
